export default "__VITE_ASSET__DYOGlRQq__"